// src/views/auth/SetFirstPassword.js
/* eslint-disable no-console */
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { toast } from "react-toastify";
import classnames from "classnames";

import Aux from "../../hoc/_Aux/Aux";
import authService from "../../services/authService";

class SetFirstPassword extends Component {
  state = {
    password: "",
    password2: "",
    errors: {},
    submitting: false,
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { password, password2 } = this.state;
    const { dictionary } = this.props.lang;
    const userId = this.props.auth.user.id;

    if (password !== password2) {
      this.setState({ errors: { password2: true } });
      toast.error(dictionary.passwordMismatch || "Passwords do not match.");
      return;
    }

    this.setState({ submitting: true, errors: {} });
    try {
      await authService.updatepassword(password, password2, userId);
      toast.success(dictionary.passwordUpdated);
      this.props.history.push("/dashboard");
    } catch (error) {
      console.error(error);
      const msg =
        error.response?.data?.password ||
        error.response?.data?.message ||
        "Error setting password.";
      toast.error(msg);
      this.setState({ submitting: false });
    }
  };

  render() {
    const { dictionary } = this.props.lang;
    const { password, password2, errors, submitting } = this.state;

    return (
      <Aux>
        <div className="auth-wrapper">
          <div className="auth-content">
            <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div>
            <div className="card">
              <div className="card-body" style={{ padding: "40px 30px" }}>
                <div className="text-center mb-4">
                  <i
                    className="feather icon-lock"
                    style={{ fontSize: 40, color: "#4e6ac5" }}
                  />
                  <h4 className="mt-3 mb-1">
                    {dictionary.setFirstPasswordTitle}
                  </h4>
                  <p className="text-muted" style={{ fontSize: 14 }}>
                    {dictionary.setFirstPasswordSubtitle}
                  </p>
                </div>

                <form onSubmit={this.handleSubmit}>
                  <div className="form-group mb-3">
                    <label>{dictionary.new} {dictionary.password}</label>
                    <input
                      type="password"
                      name="password"
                      className={classnames("form-control", {
                        "is-invalid": errors.password,
                      })}
                      placeholder={dictionary.password}
                      value={password}
                      onChange={this.handleChange}
                      required
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label>{dictionary.repeat} {dictionary.password}</label>
                    <input
                      type="password"
                      name="password2"
                      className={classnames("form-control", {
                        "is-invalid": errors.password2,
                      })}
                      placeholder={dictionary.password2}
                      value={password2}
                      onChange={this.handleChange}
                      required
                      autoComplete="new-password"
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-block w-100"
                    disabled={submitting}
                  >
                    {submitting
                      ? (dictionary.saving || "Saving…")
                      : (dictionary.setFirstPasswordButton)}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

SetFirstPassword.propTypes = {
  auth: PropTypes.object.isRequired,
  lang: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  lang: state.lang,
});

export default connect(mapStateToProps)(SetFirstPassword);
